import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  individualsService,
  CheckIndividualEmailRequest,
  CheckIndividualEmailResponse,
} from '@aslanpay/portal-common-lib';

const useCheckIndividualEmail = ({
  onSuccess,
  onError,
}: UseMutationOptions<CheckIndividualEmailResponse, Error, CheckIndividualEmailRequest>) => {
  return useMutation<CheckIndividualEmailResponse, Error, CheckIndividualEmailRequest>(
    ({ email }: CheckIndividualEmailRequest) =>
      individualsService.checkIndividualEmail({ email: email.toLowerCase() }),
    { onSuccess, onError }
  );
};

export default useCheckIndividualEmail;
